module.exports = __webpack_public_path__ + "img/undraw_empty_xct9.90bc0a2c.svg";